import styled from 'styled-components'

export const ScreenshotsContainer = styled.div`
  background-color: white;
  padding: 40px 30px;

  section#quotesSection {
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #C8C8C8;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;

    header {
      padding-bottom: 26px;
      border-bottom: 2px solid #EFEFEF;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 18px;

      h4 {
        color: #353744;
        font-weight: 900;
        font-size: 24px;
        line-height: 34px;
      }

      h6 {
        color: #3D6666;
        font-weight: 800;
        font-size: 12px;
        line-height: 18px;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }

    article {
      display: flex;
      flex-direction: column;

      strong {
        color: #353744;
        font-weight: 900;
        font-size: 14px;
        line-height: 21px;
      }

      span {
        color: #65666A;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: baseline;
        gap: 4px;
        
        h6 {
          font-weight: 800;
          font-size: 14px;
          line-height: 21px;
          color: #65666A;
          margin-top: 8px;
        }
      }

      strong + span {
        margin-top: 8px;
      }
    }

    article + article {
      margin-top: 32px;
    }
  }
`